import { Link, useParams } from "react-router-dom";
import { Box, CircularProgress, Grid, Stack, Typography } from "@mui/material";
import { Section } from "../../styles/Layout";
import { toPrice } from "../../helpers/money";
import { colors, fonts } from "../../theme";
import { useGetCollectionByHandleQuery } from "../../generated/graphql";

const Shop = () => {
  const { handle } = useParams<{ handle: string }>();
  const { data, loading } = useGetCollectionByHandleQuery({ variables: { handle: handle || "" }, skip: !handle });

  const getPrice = (product: any) => {
    if (product.priceRange.minVariantPrice.amount === product.priceRange.maxVariantPrice.amount) {
      return toPrice(product.priceRange.minVariantPrice.amount);
    } else {
      return `${toPrice(product.priceRange.minVariantPrice.amount)} - ${toPrice(product.priceRange.maxVariantPrice.amount)}`;
    }
  };

  return (
    <>
      {loading ? (
        <Box height="50vh" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <>
          <Section padding={4} justifyContent="center">
            <Typography variant="h3" align="center">
              {data?.collection?.title}
            </Typography>
          </Section>
          <Section padding={{ xs: 2, md: 2 }}>
            {data?.collection?.products.nodes.length ? (
              <Grid container spacing={2}>
                {data.collection.products.nodes.map((product) => (
                  <Grid item xs={6} sm={4} key={product.id} margin={0}>
                    <Link to={`/products/${product.id.split("Product/")[1]}`}>
                      <Box height={{ xs: "180px", md: "300px" }} width="100%" border={`2px solid ${colors.dark}`}>
                        <img src={product.images.nodes[0].src} alt={product.images.nodes[0].altText || ""} />
                      </Box>
                      <Stack gap={0.5} paddingTop={1} width="100%">
                        <Typography variant="subtitle1" fontFamily={fonts.regularBold}>
                          {product.title}
                        </Typography>
                        <Typography variant="subtitle1" fontFamily={fonts.regularBold} color="text.secondary">
                          {getPrice(product)}{" "}
                          {product.availableForSale ? ((product.totalInventory || 0) < 1 ? "(Preorder)" : "") : "(Out of stock)"}
                        </Typography>
                      </Stack>
                    </Link>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography variant="h3" fontFamily={fonts.regularBold} align="center">
                No products available at this time
              </Typography>
            )}
          </Section>
        </>
      )}
    </>
  );
};

export default Shop;
